module.exports = __webpack_public_path__ + "fonts/SFUIDisplay-Heavy.0ff9485a.woff";